import { TAO_KOE } from './../libs';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
const EN_KO = window.EN_KO = window.EN_KO || {};

class MomenteFilters {
	constructor( momentsGrid ) {
		// Init isotope instance.
		this.isoElem = new Isotope( momentsGrid, {
			itemSelector: '.mdl_moments__entry-wrapper',
			percentPosition: true,
			getSortData: {
				decade( itemElem1, itemElem2 ) {
					const itemElem = itemElem1 || itemElem2;
					const subs = itemElem.querySelector( '.mdl_moments__entry' ).getAttribute( 'data-decade' );
					return subs;
				},
				date( itemElem1, itemElem2 ) {
					const itemElem = itemElem1 || itemElem2;
					const subs = itemElem.querySelector( '.mdl_moments__entry' ).getAttribute( 'data-creation-date' );
					return subs;
				},
			},
		} );

		// Update sort data
		this.isoElem.updateSortData();

		// Rerender because of fonts
		setTimeout( () => {
			this.isoElem.layout();
		}, 100 );

		imagesLoaded( this.isoElem ).on( 'progress', () => {
			this.isoElem.layout();
		} );

		const filterBtns = document.querySelectorAll( '.mdl_moments__filter-item-choices-control--apply' );
		for ( const btn of filterBtns ) {
			btn.addEventListener( 'click', () => this.filterChanged() );
		}

		const btnCancelSubsidiaries = document.querySelector( '.cancel_subsidiaries' );
		if ( btnCancelSubsidiaries ) {
			btnCancelSubsidiaries.addEventListener( 'click', () => this.resetFilter( 'subsidiary' ) );
		}

		const btnCancelDecades = document.querySelector( '.cancel_decades' );
		if ( btnCancelDecades ) {
			btnCancelDecades.addEventListener( 'click', () => this.resetFilter( 'decade' ) );
		}

		const sortDropdown = document.querySelector( '.mdl_moments__sort-select-field' );
		if ( sortDropdown ) {
			sortDropdown.addEventListener( 'change', ( arg ) => this.sortChanged( arg ) );
		}

		this.checkAddFilterMessages();
		this.customSelect();
	}

	filterChanged = function() {
		const inputs = Array.from( document.querySelectorAll( '.mdl_moments__filter-item-choice-input' ) );
		const inputsSubsidiary = inputs.filter( ( input ) => input.name === 'subsidiary[]' && input.checked === true );
		const inputsDecades = inputs.filter( ( input ) => input.name === 'decade[]' && input.checked === true );
		const subsidiaries = inputsSubsidiary.map( ( input ) => input.id );
		const decades = inputsDecades.map( ( input ) => input.id );

		this.isoElem.arrange( {
			filter() {
				const subsidiary = this.querySelector( '.mdl_moments__entry' ).getAttribute( 'data-subsidiary' );
				const decade = this.querySelector( '.mdl_moments__entry' ).getAttribute( 'data-decade' );

				return ( subsidiaries.includes( subsidiary ) || 0 === subsidiaries.length ) &&
					( decades.includes( decade ) || 0 === decades.length );
			},
		} );
	};

	resetFilter = ( category ) => {
		let inputs = Array.from( document.querySelectorAll( '.mdl_moments__filter-item-choice-input' ) );

		if ( 'subsidiary' === category ) {
			inputs = inputs.filter( ( input ) => input.name === 'subsidiary[]' && input.checked === true );
		} else {
			inputs = inputs.filter( ( input ) => input.name === 'decade[]' && input.checked === true );
		}

		for ( const input of inputs ) {
			input.checked = false;
		}

		this.filterChanged();
	};

	sortChanged = ( arg ) => {
		const option = arg.target[ arg.target.selectedIndex ].id;
		const sortAsc = 'decade-asc' === option || 'published-asc' === option ? true : false;
		const category = 'decade-asc' === option || 'decade-desc' === option ? 'decade' : 'date';

		this.isoElem.arrange( {
			sortBy: category,
			sortAscending: sortAsc,
		} );
	};

	checkAddFilterMessages = function() {
		const filterBoxes = document.querySelectorAll( '.mdl_moments__filter-item-choices-container' );
		filterBoxes.forEach( ( filterbox ) => {
			const choices = filterbox.querySelector( '.mdl_moments__filter-item-choices' );
			if ( 0 === choices.childElementCount ) {
				filterbox.querySelector( '.mdl_moments__filter-item-choices--message' ).classList.remove( 'en_hidden' );
				choices.classList.add( 'en_hidden' );
			}
		} );
	};

	closeAllFilters = ( filter ) => {
		let items = document.querySelectorAll( '.js-filter__item' );
		if ( filter ) {
			items = filter.querySelectorAll( '.js-filter__item' );
		}

		if ( typeof items !== 'undefined' && items.length > 0 ) {
			items.forEach( function( item ) {
				item.classList.remove( 'is-open' );
			} );
		}

		filter.classList.remove( 'is-open' );
	};

	calculateFilterHeight = function() {
		// Only calculate filter height for desktop devices
		if ( window.innerWidth <= 1030 ) {
			return;
		}

		const openFilter = document.querySelector( '.mdl_moments__filter-item.is-open .mdl_moments__filter-item-choices-container' );

		// Return if no open filter has been found
		if ( typeof openFilter === 'undefined' || openFilter === null ) {
			return;
		}

		const choicesContainer = openFilter.querySelector( '.mdl_moments__filter-item-choices' );

		if ( typeof choicesContainer === 'undefined' || choicesContainer === null ) {
			return;
		}

		// Reset choicesContainer maxHeight in order to re-calculate the height depending of the initial state
		choicesContainer.removeAttribute( 'style' );

		const filterRect = openFilter.getBoundingClientRect(),
			controls = openFilter.querySelector( '.mdl_moments__filter-item-choices-controls' ),
			controlsRect = typeof controls !== 'undefined' && controls !== null ? controls.getBoundingClientRect() : false,
			windowHeight = window.innerHeight,
			PADDING = 10;

		// Return if open filter is smaller than the window height ( no calculation needed )
		if ( windowHeight >= filterRect.bottom + PADDING ) {
			return;
		}

		const newHeight = windowHeight - filterRect.top - PADDING - ( controlsRect ? controlsRect.height : 0 );

		choicesContainer.setAttribute( 'style', 'max-height: ' + newHeight + 'px;' );
	};

	openFilter = function() {
		const self = this;
		document.addEventListener( 'click', function( event ) {
			if ( typeof event.target !== 'undefined' && event.target.classList.contains( 'js-filter__item' ) ) {
				// AppHeight.setAppHeight();
				const item = event.target,
					filter = item.closest( '.mdl_moments__filter' );
				//   var container = item.querySelector( '.mdl_moments__filter-item-choices' ),
				const filterContainer = filter.querySelector( '.mdl_moments__filter-items' );
				if ( ! item.classList.contains( 'is-open' ) ) {
					self.closeAllFilters( filter );
					item.classList.add( 'is-open' );
					filter.classList.add( 'is-open' );
				} else {
					item.classList.remove( 'is-open' );
					filter.classList.remove( 'is-open' );
					filterContainer.classList.remove( 'is-overflow-scroll-disabled' );
				}

				self.calculateFilterHeight();
			}
		} );
	};

	determineFilterAlignment = function() {
		const containers = document.querySelectorAll( '.mdl_moments__filter-item-choices-container' );

		if ( typeof containers !== 'undefined' && containers.length > 0 ) {
			containers.forEach( function( container ) {
				const item = container.closest( '.mdl_moments__filter-item' );
				item.classList.remove( 'mdl_moments__filter-item--align-right' );

				const rect = EN_KO.functions.getHiddenDimensions( container ),
					rightEnd = rect.right,
					windowWidth = window.innerWidth;

				if ( windowWidth < rightEnd ) {
					item.classList.add( 'mdl_moments__filter-item--align-right' );
				}
			} );
		}
	};

	closeFilter = function() {
		const self = this;
		document.addEventListener( 'click', function( event ) {
			if ( typeof event.target !== 'undefined' && event.target.classList.contains( 'js-filter__backdrop' ) ) {
				const filter = event.target.closest( '.mdl_moments__filter' );
				self.closeAllFilters( filter );
			}
		} );

		document.addEventListener( 'click', function( event ) {
			if ( typeof event.target !== 'undefined' && event.target.classList.contains( 'js-filter__close' ) ) {
				const filter = event.target.closest( '.mdl_moments__filter' ),
					// outerContainer = event.target.closest( '.mdl_moments__filter-item-choices-container' ),
					// innerContainer = outerContainer.querySelector( '.mdl_moments__filter-item-choices' ),
					filterContainer = filter.querySelector( '.mdl_moments__filter' );
				self.closeAllFilters( filter );
				filterContainer.classList.remove( 'is-overflow-scroll-disabled' );
				// if( window.innerWidth <= 1030 ) ScrollLock.release(innerContainer);
			}
		} );
	};

	customSelect = function() {
		this.openFilter();
		this.closeFilter();

		window.addEventListener( 'resize', this.determineFilterAlignment );
		this.determineFilterAlignment();

		window.addEventListener( 'resize', this.calculateFilterHeight );
		window.addEventListener( 'scroll', this.calculateFilterHeight );
		this.calculateFilterHeight();
	};
}

TAO_KOE.ready( 'momente-filters.js', function() {
	const momentsGrid = document.querySelector( '.mdl_moments__entries-inner' );
	if ( momentsGrid ) {
		new MomenteFilters( momentsGrid );
	}
} );
